import { useQuery } from '@tanstack/react-query'
import http from '../../utils/Http/Http'

export const getCampaignById = async (id: string, signal?: AbortSignal) => {
	const url = `/campaigns/${id}`
	const res = await http({
		url,
		signal,
		method: 'get',
	})

	return res.data
}

export default function useFetchCampaign(id: string, enabled: boolean = true, refetchInterval = undefined) {
	const {
		data: campaign,
		isFetching: fetchingCampaign,
		refetch: refetchCampaign,
	} = useQuery({
		queryKey: [`campaign_${id}`],
		queryFn: ({ signal }) => getCampaignById(id, signal),
		enabled: enabled && !!id,
		refetchInterval,
	})

	return { campaign, fetchingCampaign, refetchCampaign }
}
